import { render } from "./HelpStandardProjects.vue?vue&type=template&id=2e3206d0&ts=true"
import script from "./HelpStandardProjects.vue?vue&type=script&lang=ts"
export * from "./HelpStandardProjects.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__